export * from "./PromoCardHorizontal";
